export default {"src":"/_next/static/media/romtech-logo.86a94324.svg","height":35,"width":30};